import { Outlet } from 'react-router-dom';
import { paths } from 'core/routing/paths';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { usePersistPreferredLocale } from 'layout/usePersistPreferredLocale';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

export function FocusedAssessmentLayout() {
  const persistLocale = usePersistPreferredLocale();

  return (
    <AppShell className="focused-shell" showFooter={false}>
      <header className="site-header site-header-compact">
        <div className="shell-container header-inner">
          <BrandLink to={paths.assessmentIntro} compact />
          <LanguageSwitcher onChange={persistLocale} />
        </div>
      </header>
      <ShellMain className="focused-main">
        <div className="shell-container assessment-container">
          <Outlet />
        </div>
      </ShellMain>
    </AppShell>
  );
}
